import axios from 'axios';
import ProvinciaTabla from '../types/ProvinciaTabla';

async function InsertarProvincia(ProvinciaNueva: ProvinciaTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_provincia"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "provincia": [
                {
                    "provincia": ProvinciaNueva.provincia,
                    "habilitado": ProvinciaNueva.habilitado,
                    "id_pais": ProvinciaNueva.pais_id
                }
            ]
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarProvincia;